export enum WidgetType {
  Boolean = 'BOOLEAN',
  Stepper = 'STEPPER',
  Switch = 'SWITCH'
}
